module.exports = __webpack_public_path__ + "static/media/KaTeX_Size2-Regular.f48e83b7.woff";